mod.modules.define("InstitutionalDecisions", "BaseModule", function (fn) {
	"use strict";

	var cache = {
		$toggle: null,
		$tabs: null,
		$tabContent: null
	};

	fn.prototype.init = function (params) {
		this.base("init", params);

		// Cache
		cache.$toggle = this.el.find("a.view-toggle");
		cache.$tabs = this.el.find("ul.nav-tabs");
		cache.$tabContent = this.el.find("div.tab-content");
	};

	fn.prototype.events = {
		"a.view-toggle": {
			"click": function (e, $el) {
				var text = $el.text();
				$el.text(text == "Show transactions" ? "Show top holders" : "Show transactions");
			}
		},
		"ul.nav-tabs a": {
			"click": function (e, $el) {
				cache.$tabs.find("li.active").removeClass("active");
				$el.parent().addClass("active");

				var content = $el.data("target");
				cache.$tabContent.find("div.active").removeClass("active");
				cache.$tabContent.find(content).addClass("active");
			}
		}
	};

});